import Sidebar from "@/components/Sidebar/SidebarView.vue";
import ProductPromoCode from "@/components/PromoCode/product_promo_code.vue";
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import { view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';

export default {
  name: "PromoCodesView",
  components: {
    Navbar,
    Sidebar,
    ProductPromoCode,
  },
  data() {
    return ({
      token_exists: null,
      user_details: { user_role: "" },
      is_loading_products: false,
      profile_products: [],
      catalogue_products: [],
      product_dashboard: {},
      product_dashboard_filter: "all",
    });
  },
  computed: {
    is_admin() {
      return this.token_exists && (this.user_details?.user_role === "admin" || this.user_details?.user_role === "organization admin");
    },
    filtered_products() {
      return this.filtered_dashboard_products;
    },
    filtered_dashboard_products() {
      const filters = {
        active_sale: product => this.has_active_sale(product),
        published: product => this.is_published_product(product),
        unpublished: product => !this.is_published_product(product),
        with_reviews: product => this.product_has_reviews(product),
        recent_30: product => this.product_created_within_days(product, 30),
      };
      const filter = filters[this.product_dashboard_filter];

      return filter ? (this.catalogue_products || []).filter(filter) : this.catalogue_products || [];
    },
    product_dashboard_cards() {
      return [
        { label: "Total products", value: this.get_dashboard_first(["total_count"], this.catalogue_products.length), icon: "bi-box-seam-fill", tone: "primary", filter: "all" },
        { label: "Published", value: this.get_dashboard_first(["published_count"], this.local_published_count), icon: "bi-send-check-fill", tone: "success", filter: "published" },
        { label: "Unpublished", value: this.get_dashboard_first(["unpublished_count"], this.local_unpublished_count), icon: "bi-send-x-fill", tone: "secondary", filter: "unpublished" },
        { label: "Active sales", value: this.get_dashboard_first(["active_sale_count", "sale_count"], this.local_sale_count), icon: "bi-tags-fill", tone: "warning", filter: "active_sale" },
        { label: "With reviews", value: this.get_dashboard_first(["with_reviews_count"], this.local_with_reviews_count), icon: "bi-star-fill", tone: "warning", filter: "with_reviews" },
        { label: "Recent 30 days", value: this.get_dashboard_first(["recent_30_days_count"], this.local_recent_30_count), icon: "bi-calendar-event-fill", tone: "info", filter: "recent_30" },
      ];
    },
    local_sale_count() {
      return (this.catalogue_products || []).filter(product => this.has_active_sale(product)).length;
    },
    local_published_count() {
      return (this.catalogue_products || []).filter(product => this.is_published_product(product)).length;
    },
    local_unpublished_count() {
      return this.catalogue_products.length - this.local_published_count;
    },
    local_recent_30_count() {
      return (this.catalogue_products || []).filter(product => this.product_created_within_days(product, 30)).length;
    },
    local_with_reviews_count() {
      return (this.catalogue_products || []).filter(product => this.product_has_reviews(product)).length;
    },
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details() || { user_role: "" };

    if (this.is_admin) {
      this.fetch_all_products();
    }
  },
  methods: {
    get_token() {
      return get_token();
    },
    initDataTable(id) {
      const table = $(id);

      if (!table.length) return;

      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next",
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available",
        },
      });
    },
    refresh_products_table() {
      this.$nextTick(() => {
        this.initDataTable("#catalogueProductsTable");
      });
    },
    destroy_products_table() {
      if ($.fn.DataTable.isDataTable("#catalogueProductsTable")) {
        $("#catalogueProductsTable").DataTable().destroy();
      }
    },
    fetch_all_products() {
      this.is_loading_products = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/get_all_products/`,
        method: "GET",
        headers: {
          Authorization: `Token ${this.get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.is_loading_products = false;
          if (response.status !== "success") return;
          this.destroy_products_table();
          this.product_dashboard = Object.assign({}, response.dashboard || {}, {
            data_count: response.data_count,
            total_count: response.count ?? response.dashboard?.total_count,
          });
          this.profile_products = response.data || [];
          this.catalogue_products = this.profile_products.filter(product => product?.id);
          this.refresh_products_table();
        },
        error: (response) => {
          this.is_loading_products = false;
          this.show_error(response, "An error occurred while loading company products.");
        },
      });
    },
    open_product_promo_code_manager(product) {
      if (!product?.id) return;

      this.$nextTick(() => {
        this.$refs.productPromoCodeRef?.open_product_promo_code_manager_modal?.({
          product,
          base_profile_id: product?.base_profile?.id,
        });
      });
    },
    view_product_details(product) {
      view_profile_product(this.$router, product);
    },
    handle_promo_update() {
      this.fetch_profile_products();
    },
    merge_sale_updated_product(product, product_updates) {
      const updated_product = product_updates.get(String(product?.id));
      return updated_product ? Object.assign({}, product, updated_product) : product;
    },
    update_sale_product_collection(products, product_updates) {
      return (products || [])
        .map((product) => this.merge_sale_updated_product(product, product_updates));
    },
    handle_sale_update(payload) {
      
      const assignments =payload.sale;

      const product_updates = new Map(
        assignments
          .filter((assignment) => assignment?.product?.id && assignment?.sale)
          .map((assignment) => [
            String(assignment.product.id),
            Object.assign({}, assignment.product, {
              sale: Object.assign({}, assignment.sale, {
                sale_price: assignment.sale_price,
                is_active: assignment.is_active ?? assignment.sale?.is_active,
              }),
            }),
          ]),
      );

      if (!product_updates.size) {
        this.handle_promo_update();
        return;
      }

      this.profile_products = this.update_sale_product_collection(this.profile_products, product_updates);
      this.catalogue_products = this.update_sale_product_collection(this.catalogue_products, product_updates);
    },
    fetch_profile_products() {
      this.fetch_all_products();
    },
    handle_product_dashboard_card_click(card) {
      this.destroy_products_table();
      this.product_dashboard_filter = card.filter || "all";
      this.refresh_products_table();
    },
    is_product_dashboard_card_active(card) {
      return this.product_dashboard_filter === (card.filter || "all");
    },
    get_product_profile_name(product) {
      return product?.base_profile?.company?.company_name ||
        [product?.base_profile?.user?.first_name, product?.base_profile?.user?.last_name].filter(Boolean).join(" ") ||
        "--";
    },
    get_product_business_name(product) {
      return this.get_product_profile_name(product);
    },
    has_active_sale(product) {
    
      const sale = product?.sale || {};
      return Boolean(sale?.is_active && Number(sale?.discount_amount || sale?.sale_price) > 0);
    },
    is_active_product(product) {
      if ([undefined, null, ""].includes(product?.is_active)) return true;
      return product?.is_active === true || product?.is_active === "true";
    },
    is_published_product(product) {
      const value = product?.is_published;
      return value === true || value === "true";
    },
    product_has_images(product) {
      return Boolean(
        product?.images?.length
      );
    },
    product_has_reviews(product) {
      return Boolean(
        Number(product?.total_reviews || 0) > 0 ||
        product?.reviews?.length
      );
    },
    product_created_within_days(product, days) {
      const created_at = product?.created_at;
      if (!created_at) return false;

      const created_date = new Date(created_at);
      const cutoff = new Date();
      cutoff.setDate(cutoff.getDate() - days);

      return created_date >= cutoff;
    },
    get_dashboard_first(keys, fallback = 0) {
      const key = keys.find((dashboard_key) =>
        ![undefined, null, ""].includes(Reflect.get(this.product_dashboard || {}, dashboard_key))
      );
      const value = Reflect.get(this.product_dashboard || {}, key);
      return [undefined, null, ""].includes(value) ? fallback : value;
    },
    show_error(response, fallback) {
      const response_data = response?.responseJSON || {};
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response_data.message || fallback,
        showConfirmButton: false,
        timer: 3000,
      });
    },
  },
};
